import PaperLayoutEditorPage from './admin/PaperLayoutEditorPage';

// 공유 링크용 뷰어 — 에디터를 shareId 모드로 재사용
export default function PaperLayoutViewPage() {
  return <PaperLayoutEditorPage />;
}
